module.exports = __webpack_public_path__ + "img/xNew.68bab344.jpg";